import * as ActionTypes from '../actions/playgroundActions';

export const playground = (
  state = {
    threads: [],
    selectedThread: null,
    messages: [],
    brief: null,
    briefComplete: false,
    isLoading: false,
    datakeeperLoading: false,
    error: null,
    llmContext: { systemPrompt: '', model: '', shopperLLMBio: '', tokenCount: 0, latencyMs: 0 },
    inlineDispatcherPrompt: '',
    inlineDatakeeperPrompt: '',
    selectedModel: 'anthropic/claude-opus-4.5',
    availableModels: [],
    promptConfigs: [],
    datakeeperResult: null,
    bottomPanelHeight: 280,
    bottomPanelCollapsed: false,
    lastSavedSession: null,
    sessions: [],
    sessionsLoading: false,
    productRecs: [],
    productRecsLoading: false
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.PLAYGROUND_SET_LOADING:
      return { ...state, isLoading: action.isLoading };

    case ActionTypes.PLAYGROUND_SET_ERROR:
      return { ...state, error: action.error };

    case ActionTypes.PLAYGROUND_SET_THREADS:
      return { ...state, threads: action.threads };

    case ActionTypes.PLAYGROUND_SELECT_THREAD:
      return {
        ...state,
        selectedThread: action.thread,
        // Reset conversation state when switching threads
        messages: [],
        brief: null,
        briefComplete: false,
        datakeeperResult: null,
        productRecs: [],
        lastSavedSession: null
      };

    case ActionTypes.PLAYGROUND_UPDATE_THREAD:
      return {
        ...state,
        threads: state.threads.map(t => (t.id === action.thread.id ? action.thread : t)),
        selectedThread: state.selectedThread?.id === action.thread.id ? action.thread : state.selectedThread
      };

    case ActionTypes.PLAYGROUND_ADD_THREAD:
      return { ...state, threads: [action.thread, ...state.threads] };

    case ActionTypes.PLAYGROUND_REMOVE_THREAD:
      return {
        ...state,
        threads: state.threads.filter(t => t.id !== action.threadId),
        selectedThread: state.selectedThread?.id === action.threadId ? null : state.selectedThread,
        messages: state.selectedThread?.id === action.threadId ? [] : state.messages
      };

    case ActionTypes.PLAYGROUND_SET_MESSAGES:
      return { ...state, messages: action.messages };

    case ActionTypes.PLAYGROUND_ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.message]
      };

    case ActionTypes.PLAYGROUND_CLEAR_CONVERSATION:
      return {
        ...state,
        messages: [],
        brief: null,
        briefComplete: false,
        llmContext: { ...state.llmContext, tokenCount: 0, latencyMs: 0 },
        datakeeperResult: null,
        productRecs: [],
        lastSavedSession: null
      };

    case ActionTypes.PLAYGROUND_SET_BRIEF:
      return {
        ...state,
        brief: action.brief,
        briefComplete: action.briefComplete
      };

    case ActionTypes.PLAYGROUND_SET_LLM_CONTEXT:
      return { ...state, llmContext: action.llmContext };

    case ActionTypes.PLAYGROUND_SET_MODEL:
      return { ...state, selectedModel: action.model };

    case ActionTypes.PLAYGROUND_SET_MODELS:
      return { ...state, availableModels: action.models };

    case ActionTypes.PLAYGROUND_SET_DISPATCHER_PROMPT:
      return { ...state, inlineDispatcherPrompt: action.prompt };

    case ActionTypes.PLAYGROUND_SET_DATAKEEPER_PROMPT:
      return { ...state, inlineDatakeeperPrompt: action.prompt };

    case ActionTypes.PLAYGROUND_SET_PROMPT_CONFIGS:
      return { ...state, promptConfigs: action.configs };

    case ActionTypes.PLAYGROUND_SET_DATAKEEPER_RESULT:
      return { ...state, datakeeperResult: action.datakeeperResult };

    case ActionTypes.PLAYGROUND_TRUNCATE_CONVERSATION:
      return {
        ...state,
        messages: state.messages.slice(0, action.index),
        brief: null,
        briefComplete: false,
        productRecs: []
      };

    case ActionTypes.PLAYGROUND_SET_BOTTOM_PANEL_HEIGHT:
      return { ...state, bottomPanelHeight: action.height };

    case ActionTypes.PLAYGROUND_SET_BOTTOM_PANEL_COLLAPSED:
      return { ...state, bottomPanelCollapsed: action.collapsed };

    case ActionTypes.PLAYGROUND_SET_LAST_SAVED_SESSION:
      return { ...state, lastSavedSession: action.session };

    case ActionTypes.PLAYGROUND_SET_SESSIONS:
      return { ...state, sessions: action.sessions };

    case ActionTypes.PLAYGROUND_SET_DATAKEEPER_LOADING:
      return { ...state, datakeeperLoading: action.loading };

    case ActionTypes.PLAYGROUND_SET_SESSIONS_LOADING:
      return { ...state, sessionsLoading: action.loading };

    case ActionTypes.PLAYGROUND_SET_PRODUCT_RECS:
      return { ...state, productRecs: action.productRecs };

    case ActionTypes.PLAYGROUND_SET_PRODUCT_RECS_LOADING:
      return { ...state, productRecsLoading: action.loading };

    default:
      return state;
  }
};
